// extracted by mini-css-extract-plugin
export default {"container":"Doctor_container__ONV2K","bg":"Doctor_bg__w2B-e","left":"Doctor_left__h3Lr1","key":"Doctor_key__r9v0y","right":"Doctor_right__54mAc"};